import React from "react";

const FreeSeminarBtn = () => (
  <button
    className="font-titleFont py-3 xl:text-xl border 
  bg-greenLight hover:bg-primeColor transition-hover duration-300 text-white font-semibold px-6 xl:py-3 rounded-sm"
  >
    Free Seminar
  </button>
);

export default FreeSeminarBtn;
